export default __webpack_public_path__ + "static/media/Ed_Commands.6260cc0c.svg";